import React from "react";
import {
    Form,
    Col,
    Card,
    InputGroup,
    Row,
    Button,
    Accordion,
} from "react-bootstrap";
import ReactModal from "react-modal";

import { Formik } from "formik";
import * as yup from "yup";
import "../../../modals/add-pricing-template/add-pricing-template.scss";
import Loader from "../../../loader/loader";

const schema = yup.object({
    showRequiredField: yup.string().oneOf(["yes", "no"]),
    price_2_percent: yup
        .number()
        .nullable()
        .when(
            ["qualifiedtype", "showRequiredField"],
            (tier, fieldRequired, schema) => {
                return fieldRequired === "no" ||
                    tier === "tiered" ||
                    tier === "sccd"
                    ? schema
                    : schema.required("* Passthrough percent is required");
            },
        ),

    price_2_dollars: yup
        .number()
        .nullable()
        .when(
            ["qualifiedtype", "showRequiredField"],
            (tier, fieldRequired, schema) => {
                return fieldRequired === "no" ||
                    tier === "tiered" ||
                    tier === "sccd"
                    ? schema
                    : schema.required("* Passthrough is required");
            },
        ),
    price_5_percent: yup
        .number()
        .nullable()
        .when(
            ["debit_pin", "showRequiredField", "qualifiedtype"],
            (pinDebit, fieldRequired, qualifiedtype, schema) => {
                return fieldRequired === "no" ||
                    pinDebit === "no" ||
                    qualifiedtype == "sccd"
                    ? schema
                    : schema.required("* Pin Debit percent is required");
            },
        ),

    price_5_dollars: yup
        .number()
        .nullable()
        .when(
            ["debit_pin", "showRequiredField", "qualifiedtype"],
            (pinDebit, fieldRequired, qualifiedtype, schema) => {
                return fieldRequired === "no" ||
                    pinDebit === "no" ||
                    qualifiedtype == "sccd"
                    ? schema
                    : schema.required("* Pin Debit dollar is required");
            },
        ),

    price_17_dollars: yup
        .number()
        .nullable()
        .when(
            ["qualifiedtype", "showRequiredField"],
            (tier, fieldRequired, schema) => {
                return fieldRequired === "no" || tier === "sccd"
                    ? schema
                    : schema.required("* Service fee is required");
            },
        ),

    price_14_dollars: yup
        .number()
        .nullable()
        .when(
            ["qualifiedtype", "showRequiredField"],
            (tier, fieldRequired, schema) => {
                return fieldRequired === "no" || tier === "sccd"
                    ? schema
                    : schema.required("* Batch Header fee is required");
            },
        ),
    price_20_dollars: yup
        .number()
        .nullable()
        .when(
            ["qualifiedtype", "showRequiredField"],
            (tier, fieldRequired, schema) => {
                return fieldRequired === "no"
                    ? schema
                    : schema.required("* Chargeback is required");
            },
        ),
    price_21_dollars: yup
        .number()
        .nullable()
        .when(
            ["qualifiedtype", "showRequiredField"],
            (tier, fieldRequired, schema) => {
                return fieldRequired === "no"
                    ? schema
                    : schema.required("* Retrieval is required");
            },
        ),
    price_22_dollars: yup
        .number()
        .nullable()
        .when(
            ["qualifiedtype", "showRequiredField"],
            (tier, fieldRequired, schema) => {
                return fieldRequired === "no"
                    ? schema
                    : schema.required("* NSF/ACH is required");
            },
        ),

    price_32_percent: yup
        .number()
        .nullable()
        .when(
            ["apexoptout", "qualifiedtype", "showRequiredField"],
            (optAmerican, tier, fieldRequired, schema) => {
                return fieldRequired === "no" ||
                    tier !== "tiered" ||
                    optAmerican === "yes"
                    ? schema
                    : schema.required("* Required");
            },
        ),

    price_33_percent: yup
        .number()
        .nullable()
        .when(
            ["apexoptout", "qualifiedtype", "showRequiredField"],
            (optAmerican, tier, fieldRequired, schema) => {
                return fieldRequired === "no" ||
                    tier !== "tiered" ||
                    optAmerican === "yes"
                    ? schema
                    : schema.required("* Required");
            },
        ),

    price_34_percent: yup
        .number()
        .nullable()
        .when(
            ["apexoptout", "qualifiedtype", "showRequiredField"],
            (optAmerican, tier, fieldRequired, schema) => {
                return fieldRequired === "no" ||
                    tier !== "tiered" ||
                    optAmerican === "yes"
                    ? schema
                    : schema.required("* Required");
            },
        ),

    price_32_dollars: yup
        .number()
        .nullable()
        .when(
            ["apexoptout", "qualifiedtype", "showRequiredField"],
            (optAmerican, tier, fieldRequired, schema) => {
                return fieldRequired === "no" ||
                    tier !== "tiered" ||
                    optAmerican === "yes"
                    ? schema
                    : schema.required("* Required");
            },
        ),

    price_33_dollars: yup
        .number()
        .nullable()
        .when(
            ["apexoptout", "qualifiedtype", "showRequiredField"],
            (optAmerican, tier, fieldRequired, schema) => {
                return fieldRequired === "no" ||
                    tier !== "tiered" ||
                    optAmerican === "yes"
                    ? schema
                    : schema.required("* Required");
            },
        ),

    price_34_dollars: yup
        .number()
        .nullable()
        .when(
            ["apexoptout", "qualifiedtype", "showRequiredField"],
            (optAmerican, tier, fieldRequired, schema) => {
                return fieldRequired === "no" ||
                    tier !== "tiered" ||
                    optAmerican === "yes"
                    ? schema
                    : schema.required("* Required");
            },
        ),

    price_1_percent: yup
        .number()
        .nullable()
        .typeError("you must specify a number"),
    price_1_dollars: yup
        .number()
        .nullable()
        .typeError("you must specify a number"),
    price_3_percent: yup
        .number()
        .nullable()
        .typeError("you must specify a number"),
    price_3_dollars: yup
        .number()
        .nullable()
        .typeError("you must specify a number"),
    price_4_percent: yup
        .number()
        .nullable()
        .typeError("you must specify a number"),
    price_4_dollars: yup
        .number()
        .nullable()
        .typeError("you must specify a number"),
    price_6_percent: yup
        .number()
        .nullable()
        .typeError("you must specify a number"),
    price_6_dollars: yup
        .number()
        .nullable()
        .typeError("you must specify a number"),
    price_11_dollars: yup
        .number()
        .nullable()
        .typeError("you must specify a number"),
    price_12_dollars: yup
        .number()
        .nullable()
        .typeError("you must specify a number"),
    price_18_dollars: yup
        .number()
        .nullable()
        .typeError("you must specify a number"),
    price_25_dollars: yup
        .number()
        .nullable()
        .typeError("you must specify a number"),
    price_13_dollars: yup
        .number()
        .nullable()
        .typeError("you must specify a number"),
    price_27_dollars: yup
        .number()
        .nullable()
        .typeError("you must specify a number"),
    price_35_percent: yup
        .number()
        .nullable()
        .typeError("you must specify a number"),
    price_35_dollars: yup
        .number()
        .nullable()
        .typeError("you must specify a number"),
});

const pricing_data = {
    showRequiredField: "yes",
    qualifiedtype: "tiered",
    apexoptout: "no",
    debit_pin: "no",
    ebt_fees: "no",
    merchant_type_id: "",
    price_1_dollars: "",
    price_2_dollars: "",
    price_3_dollars: "",
    price_4_dollars: "",
    price_5_dollars: "",
    price_6_dollars: "",
    price_7_dollars: "",
    price_8_dollars: "",
    price_9_dollars: "",
    price_10_dollars: "",
    price_11_dollars: "",
    price_12_dollars: "",
    price_13_dollars: "",
    price_14_dollars: "",
    price_15_dollars: "",
    price_16_dollars: "",
    price_17_dollars: "",
    price_18_dollars: "",
    price_19_dollars: "",
    price_20_dollars: 40,
    price_21_dollars: 25,
    price_22_dollars: 35,
    price_23_dollars: "",
    price_25_dollars: "",
    price_27_dollars: "",
    price_28_dollars: "",
    price_29_dollars: "",
    price_30_dollars: "",
    price_31_dollars: "",
    price_32_dollars: "",
    price_33_dollars: "",
    price_34_dollars: "",
    price_35_dollars: "",
    price_36_dollars: "",
    price_37_dollars: "",
    price_1_percent: "",
    price_2_percent: "",
    price_3_percent: "",
    price_4_percent: "",
    price_5_percent: "",
    price_6_percent: "",
    price_7_percent: "",
    price_8_percent: "",
    price_9_percent: "",
    price_10_percent: "",
    price_24_percent: "",
    price_26_percent: "",
    price_32_percent: "",
    price_33_percent: "",
    price_34_percent: "",
    price_35_percent: "",
    price_36_percent: "",
    price_37_percent: "",
};

class EditPricingCreateApp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isEdit: true,
            saveas: 1,
            pricing_template_name: props.selectedTemplate
                ? props.selectedTemplate.pricing_template_name
                : "",
            showSave: false,
            saveConfirmationOpen: false,
            is_submitted: false,
            formData:
                this.props.pricingData !== ""
                    ? this.props.pricingData
                    : pricing_data,
            errors: [],
            show_spinner: false,
            errorMessage: "",
        };
    }

    handleAddTemplate(evt) {
        this.props.setData(this.state.formData);
    }

    updateChange(evt) {
        const targetName = evt.target.name;
        if (targetName == "template_name") {
            let formData = this.state.formData;
            formData[targetName] = evt.target.value;
            this.setState({ formData: formData, errorMessage: "" });
        } else {
            if (targetName === "") {
                return false;
            }
            let formData = this.state.formData;
            formData[targetName] = evt.target.value.trim();
            this.setState({ formData: formData, errorMessage: "" });
        }
    }

    copyValues = (values) => {
        const new_values = {
            ...values,
            price_32_percent: values.price_1_percent,
            price_32_dollars: values.price_1_dollars,
            price_33_percent: values.price_3_percent,
            price_33_dollars: values.price_3_dollars,
            price_34_percent: values.price_4_percent,
            price_34_dollars: values.price_4_dollars,
        };
        this.setState({ formData: new_values });
    };

    render() {
        const { is_submitted, formData, errors, isEdit, show_spinner } =
            this.state;
        return (
            <ReactModal
                isOpen={this.props.show}
                className="add-pricing-template-modal"
            >
                <div
                    onClick={() => this.props.handleClose()}
                    className="modal-cancel"
                >
                    <img src="/images/cancel.svg" />
                </div>
                <div className="modal-header">
                    <h4 className="text-left">
                        {isEdit ? "Edit Template" : "Add Template"}
                    </h4>
                </div>
                <div className="modal-body">
                    <Formik
                        enableReinitialize
                        validationSchema={schema}
                        onSubmit={(e) => this.handleAddTemplate(e)}
                        initialValues={
                            this.props.selectedTemplate
                                ? JSON.parse(
                                      this.props.selectedTemplate
                                          .pricing_template,
                                  )
                                : formData
                        }
                        initialErrors={errors}
                        validateOnBlur={false}
                        validateOnChange={is_submitted}
                        validate={(values) => {
                            this.setState({ is_submitted: true });
                        }}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            values,
                            touched,
                            errors,
                            isSubmitting,
                        }) => (
                            <Form
                                noValidate
                                id="pricing-form"
                                className="pricing-frm pricing-frm"
                                onSubmit={handleSubmit}
                                onChange={(e) => this.updateChange(e)}
                                autoComplete="off"
                            >
                                <Form.Row className="priceing-wrap">
                                    <Form.Group
                                        as={Col}
                                        xs={10}
                                        lg={10}
                                        controlId="prior_data_compromise_invetigation"
                                        className="px-3 div-processing"
                                    >
                                        <div className="d-flex tire-new">
                                            <label className="radio-container">
                                                <input
                                                    type="radio"
                                                    name="qualifiedtype"
                                                    value="tiered"
                                                    checked={
                                                        values.qualifiedtype ===
                                                        "tiered"
                                                    }
                                                    onChange={handleChange}
                                                />
                                                <span className="checkmark"></span>
                                                <span className="rd-label">
                                                    Tiered
                                                </span>
                                            </label>
                                            <label className="radio-container">
                                                <input
                                                    type="radio"
                                                    name="qualifiedtype"
                                                    value="icppt"
                                                    checked={
                                                        values.qualifiedtype ===
                                                        "icppt"
                                                    }
                                                    onChange={handleChange}
                                                />
                                                <span className="checkmark"></span>
                                                <span className="rd-label">
                                                    IC Plus / Pass-Through
                                                </span>
                                            </label>
                                            <label className="radio-container">
                                                <input
                                                    type="radio"
                                                    name="qualifiedtype"
                                                    value="sccd"
                                                    checked={
                                                        values.qualifiedtype ===
                                                        "sccd"
                                                    }
                                                    onChange={handleChange}
                                                />
                                                <span className="checkmark"></span>
                                                <span className="rd-label">
                                                    Surcharge / Cash Discount
                                                </span>
                                            </label>
                                            <label className="radio-container">
                                                <input
                                                    type="radio"
                                                    name="qualifiedtype"
                                                    value="frate"
                                                    checked={
                                                        values.qualifiedtype ===
                                                        "frate"
                                                    }
                                                    onChange={handleChange}
                                                />
                                                <span className="checkmark"></span>
                                                <span className="rd-label">
                                                    Flat Rate
                                                </span>
                                            </label>
                                        </div>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {/*errors.prior_data_compromise_invetigation */}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    {values.qualifiedtype === "sccd" && (
                                        <div className="new-div row px-3 non-tired">
                                            <h2 className="price-frm-heading cardholder">
                                                Charged to Credit Cardholder at
                                                Point-of-Sale
                                            </h2>

                                            <Form.Row>
                                                <Form.Group as={Col} sm={6}>
                                                    <Form.Label>
                                                        Discount Rate (Per
                                                        Transaction)
                                                    </Form.Label>
                                                </Form.Group>

                                                <Form.Group
                                                    as={Col}
                                                    sm={4}
                                                    controlId="price_35_percent"
                                                    className="col-8"
                                                >
                                                    <InputGroup>
                                                        <InputGroup.Append>
                                                            <InputGroup.Text id="inputGroupPrepend">
                                                                %
                                                            </InputGroup.Text>
                                                        </InputGroup.Append>
                                                        <Form.Control
                                                            type="text"
                                                            name="price_35_percent"
                                                            value={
                                                                values.price_35_percent
                                                            }
                                                            onChange={
                                                                handleChange
                                                            }
                                                            aria-describedby="inputGroupPrepend"
                                                            required
                                                            className="preapp-form-input"
                                                        />

                                                        <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                    </InputGroup>
                                                    <Form.Control.Feedback
                                                        type="invalid"
                                                        className="text-capitalize"
                                                    >
                                                        {
                                                            errors.price_35_percent
                                                        }
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Form.Row>
                                        </div>
                                    )}
                                    {(values.qualifiedtype === "icppt" ||
                                        values.qualifiedtype === "frate") && (
                                        <div className="new-div row px-3 non-tired">
                                            <Form.Row>
                                                <Form.Group as={Col} sm={6}>
                                                    <Form.Label>
                                                        Passthrough (per item)
                                                    </Form.Label>
                                                </Form.Group>

                                                <Form.Group
                                                    as={Col}
                                                    sm={4}
                                                    controlId="price_2_percent"
                                                    className="col-8 "
                                                >
                                                    <InputGroup>
                                                        <InputGroup.Append>
                                                            <InputGroup.Text id="inputGroupPrepend">
                                                                %
                                                            </InputGroup.Text>
                                                        </InputGroup.Append>
                                                        <Form.Control
                                                            type="text"
                                                            name="price_2_percent"
                                                            value={
                                                                values.price_2_percent
                                                            }
                                                            onChange={
                                                                handleChange
                                                            }
                                                            aria-describedby="inputGroupPrepend"
                                                            required
                                                            className="preapp-form-input"
                                                            isInvalid={
                                                                touched.price_2_percent &&
                                                                !!errors.price_2_percent
                                                            }
                                                            isValid={
                                                                is_submitted &&
                                                                !errors.price_2_percent
                                                            }
                                                        />
                                                    </InputGroup>
                                                    <Form.Control.Feedback
                                                        type="invalid"
                                                        className="text-capitalize"
                                                    >
                                                        {errors.price_2_percent}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group
                                                    as={Col}
                                                    sm={2}
                                                    controlId="price_2_dollars"
                                                    className="col-4"
                                                >
                                                    <InputGroup>
                                                        <Form.Control
                                                            type="text"
                                                            name="price_2_dollars"
                                                            value={
                                                                values.price_2_dollars
                                                            }
                                                            onChange={
                                                                handleChange
                                                            }
                                                            aria-describedby="inputGroupPrepend"
                                                            required
                                                            className="preapp-form-input"
                                                            isInvalid={
                                                                touched.price_2_dollars &&
                                                                !!errors.price_2_dollars
                                                            }
                                                            isValid={
                                                                is_submitted &&
                                                                !errors.price_2_dollars
                                                            }
                                                        />
                                                        <InputGroup.Prepend>
                                                            <InputGroup.Text id="inputGroupPrepend">
                                                                $
                                                            </InputGroup.Text>
                                                        </InputGroup.Prepend>
                                                    </InputGroup>
                                                    <Form.Control.Feedback
                                                        type="invalid"
                                                        className="text-capitalize"
                                                    >
                                                        {errors.price_2_dollars}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Form.Row>
                                        </div>
                                    )}
                                    {values.qualifiedtype === "tiered" && (
                                        <div className="new-div row px-3 ">
                                            <Form.Row>
                                                <Form.Group as={Col} sm={6}>
                                                    <Form.Label>
                                                        Qualified-tiered (Per
                                                        Item)
                                                    </Form.Label>
                                                </Form.Group>

                                                <Form.Group
                                                    as={Col}
                                                    sm={4}
                                                    controlId="price_1_percent"
                                                    className="px-3 col-8"
                                                >
                                                    <InputGroup>
                                                        <InputGroup.Append>
                                                            <InputGroup.Text id="inputGroupPrepend">
                                                                %
                                                            </InputGroup.Text>
                                                        </InputGroup.Append>
                                                        <Form.Control
                                                            type="text"
                                                            name="price_1_percent"
                                                            value={
                                                                values.price_1_percent
                                                            }
                                                            onChange={
                                                                handleChange
                                                            }
                                                            aria-describedby="inputGroupPrepend"
                                                            required
                                                            className="preapp-form-input pl-2"
                                                        />
                                                    </InputGroup>
                                                    <Form.Control.Feedback
                                                        type="invalid"
                                                        className="text-capitalize"
                                                    >
                                                        {errors.price_1_percent}
                                                    </Form.Control.Feedback>
                                                </Form.Group>

                                                <Form.Group
                                                    as={Col}
                                                    sm={2}
                                                    controlId="price_1_dollars"
                                                    className="px-3 col-4"
                                                >
                                                    <InputGroup>
                                                        <Form.Control
                                                            type="text"
                                                            name="price_1_dollars"
                                                            value={
                                                                values.price_1_dollars
                                                            }
                                                            onChange={
                                                                handleChange
                                                            }
                                                            aria-describedby="inputGroupPrepend"
                                                            required
                                                            className="preapp-form-input"
                                                        />
                                                        <InputGroup.Prepend>
                                                            <InputGroup.Text id="inputGroupPrepend">
                                                                $
                                                            </InputGroup.Text>
                                                        </InputGroup.Prepend>
                                                        <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                    </InputGroup>
                                                    <Form.Control.Feedback
                                                        type="invalid"
                                                        className="text-capitalize"
                                                    >
                                                        {errors.price_1_dollars}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Form.Row>
                                        </div>
                                    )}

                                    {values.qualifiedtype === "tiered" && (
                                        <div className="new-div row px-3 ">
                                            <Form.Row>
                                                <Form.Group as={Col} sm={6}>
                                                    <Form.Label>
                                                        Mid-tiered (Per item):
                                                    </Form.Label>
                                                </Form.Group>

                                                <Form.Group
                                                    as={Col}
                                                    sm={4}
                                                    controlId="price_3_percent"
                                                    className="px-3 col-8"
                                                >
                                                    <InputGroup>
                                                        <InputGroup.Append>
                                                            <InputGroup.Text id="inputGroupPrepend">
                                                                %
                                                            </InputGroup.Text>
                                                        </InputGroup.Append>
                                                        <Form.Control
                                                            type="text"
                                                            name="price_3_percent"
                                                            value={
                                                                values.price_3_percent
                                                            }
                                                            onChange={
                                                                handleChange
                                                            }
                                                            aria-describedby="inputGroupPrepend"
                                                            required
                                                            className="preapp-form-input"
                                                        />

                                                        <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                    </InputGroup>
                                                    <Form.Control.Feedback
                                                        type="invalid"
                                                        className="text-capitalize"
                                                    >
                                                        {errors.price_3_percent}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group
                                                    as={Col}
                                                    sm={2}
                                                    controlId="price_3_dollars"
                                                    className="px-3 col-4"
                                                >
                                                    <InputGroup>
                                                        <Form.Control
                                                            type="text"
                                                            name="price_3_dollars"
                                                            value={
                                                                values.price_3_dollars
                                                            }
                                                            onChange={
                                                                handleChange
                                                            }
                                                            aria-describedby="inputGroupPrepend"
                                                            required
                                                            className="preapp-form-input"
                                                        />
                                                        <InputGroup.Prepend>
                                                            <InputGroup.Text id="inputGroupPrepend">
                                                                $
                                                            </InputGroup.Text>
                                                        </InputGroup.Prepend>
                                                        <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                    </InputGroup>
                                                    <Form.Control.Feedback
                                                        type="invalid"
                                                        className="text-capitalize"
                                                    >
                                                        {errors.price_3_dollars}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Form.Row>
                                        </div>
                                    )}
                                    {values.qualifiedtype === "tiered" && (
                                        <div className="new-div row px-3">
                                            <Form.Row>
                                                <Form.Group as={Col} sm={6}>
                                                    <Form.Label>
                                                        Non-tiered (Per Item)
                                                    </Form.Label>
                                                </Form.Group>

                                                <Form.Group
                                                    as={Col}
                                                    sm={4}
                                                    controlId="price_4_percent"
                                                    className="px-3 col-8"
                                                >
                                                    <InputGroup>
                                                        <InputGroup.Append>
                                                            <InputGroup.Text id="inputGroupPrepend">
                                                                %
                                                            </InputGroup.Text>
                                                        </InputGroup.Append>
                                                        <Form.Control
                                                            type="text"
                                                            name="price_4_percent"
                                                            value={
                                                                values.price_4_percent
                                                            }
                                                            onChange={
                                                                handleChange
                                                            }
                                                            aria-describedby="inputGroupPrepend"
                                                            required
                                                            className="preapp-form-input"
                                                        />

                                                        <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                    </InputGroup>
                                                    <Form.Control.Feedback
                                                        type="invalid"
                                                        className="text-capitalize"
                                                    >
                                                        {errors.price_4_percent}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group
                                                    as={Col}
                                                    sm={2}
                                                    controlId="price_4_dollars"
                                                    className="px-3 col-4"
                                                >
                                                    <InputGroup>
                                                        <Form.Control
                                                            type="text"
                                                            name="price_4_dollars"
                                                            value={
                                                                values.price_4_dollars
                                                            }
                                                            onChange={
                                                                handleChange
                                                            }
                                                            aria-describedby="inputGroupPrepend"
                                                            required
                                                            className="preapp-form-input"
                                                        />
                                                        <InputGroup.Prepend>
                                                            <InputGroup.Text id="inputGroupPrepend">
                                                                $
                                                            </InputGroup.Text>
                                                        </InputGroup.Prepend>
                                                        <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                    </InputGroup>
                                                    <Form.Control.Feedback
                                                        type="invalid"
                                                        className="text-capitalize"
                                                    >
                                                        {errors.price_4_dollars}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Form.Row>
                                        </div>
                                    )}
                                    {values.qualifiedtype !== "sccd" && (
                                        <div className="new-div row px-3 pindebit">
                                            <div className="pri-heading">
                                                Pin Debit
                                            </div>
                                            <div className=" ">
                                                <div className=" pri-heading1"></div>
                                                <Form.Group
                                                    as={Col}
                                                    xs={12}
                                                    controlId="apexoptout"
                                                    className="px-3"
                                                >
                                                    <div>
                                                        <label className="radio-container">
                                                            <input
                                                                type="radio"
                                                                name="debit_pin"
                                                                value="yes"
                                                                checked={
                                                                    values.debit_pin ===
                                                                    "yes"
                                                                }
                                                                onChange={
                                                                    handleChange
                                                                }
                                                            />
                                                            <span className="checkmark"></span>
                                                            <span className="rd-label">
                                                                Yes
                                                            </span>
                                                        </label>
                                                        <label className="radio-container">
                                                            <input
                                                                type="radio"
                                                                name="debit_pin"
                                                                value="no"
                                                                checked={
                                                                    values.debit_pin ===
                                                                    "no"
                                                                }
                                                                onChange={
                                                                    handleChange
                                                                }
                                                            />
                                                            <span className="checkmark"></span>
                                                            <span className="rd-label">
                                                                No
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <Form.Control.Feedback
                                                        type="invalid"
                                                        className="text-capitalize"
                                                    >
                                                        {errors.debit_pin}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </div>
                                        </div>
                                    )}
                                    {values.debit_pin == "yes" &&
                                    values.qualifiedtype !== "sccd" ? (
                                        <div className="new-div row px-3 ">
                                            <Form.Row>
                                                <Form.Group as={Col} sm={6}>
                                                    <Form.Label>
                                                        PIN Debit
                                                    </Form.Label>
                                                    <div className="float-right">
                                                        {values.qualifiedtype ===
                                                        "icppt" ? (
                                                            <span>IC+</span>
                                                        ) : (
                                                            ""
                                                        )}
                                                    </div>
                                                </Form.Group>
                                                <Form.Group
                                                    as={Col}
                                                    sm={4}
                                                    controlId="price_5_percent"
                                                    className="px-3 col-8"
                                                >
                                                    <InputGroup>
                                                        <InputGroup.Append>
                                                            <InputGroup.Text id="inputGroupPrepend">
                                                                %
                                                            </InputGroup.Text>
                                                        </InputGroup.Append>
                                                        <Form.Control
                                                            type="text"
                                                            name="price_5_percent"
                                                            value={
                                                                values.price_5_percent
                                                            }
                                                            onChange={
                                                                handleChange
                                                            }
                                                            aria-describedby="inputGroupPrepend"
                                                            required
                                                            className="preapp-form-input"
                                                            isInvalid={
                                                                touched.price_5_percent &&
                                                                !!errors.price_5_percent
                                                            }
                                                            isValid={
                                                                is_submitted &&
                                                                !errors.price_5_percent
                                                            }
                                                        />
                                                    </InputGroup>
                                                    <Form.Control.Feedback
                                                        type="invalid"
                                                        className="text-capitalize"
                                                    >
                                                        {errors.price_5_percent}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group
                                                    as={Col}
                                                    sm={2}
                                                    controlId="price_5_dollars"
                                                    className="px-3 col-4"
                                                >
                                                    <InputGroup>
                                                        <Form.Control
                                                            type="text"
                                                            name="price_5_dollars"
                                                            value={
                                                                values.price_5_dollars
                                                            }
                                                            onChange={
                                                                handleChange
                                                            }
                                                            aria-describedby="inputGroupPrepend"
                                                            required
                                                            className="preapp-form-input"
                                                            isInvalid={
                                                                touched.price_5_dollars &&
                                                                !!errors.price_5_dollars
                                                            }
                                                            isValid={
                                                                is_submitted &&
                                                                !errors.price_5_dollars
                                                            }
                                                        />
                                                        <InputGroup.Prepend>
                                                            <InputGroup.Text id="inputGroupPrepend">
                                                                $
                                                            </InputGroup.Text>
                                                        </InputGroup.Prepend>
                                                    </InputGroup>
                                                    <Form.Control.Feedback
                                                        type="invalid"
                                                        className="text-capitalize"
                                                    >
                                                        {errors.price_5_dollars}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Form.Row>
                                        </div>
                                    ) : (
                                        <div></div>
                                    )}
                                    {values.qualifiedtype !== "sccd" && (
                                        <div className="new-div row px-3 ">
                                            <Form.Row>
                                                <Form.Group as={Col} sm={6}>
                                                    <Form.Label>
                                                        Signature Debit
                                                    </Form.Label>
                                                    <div className="float-right">
                                                        {values.qualifiedtype ===
                                                        "icppt" ? (
                                                            <span>IC+</span>
                                                        ) : (
                                                            ""
                                                        )}
                                                    </div>
                                                </Form.Group>

                                                <Form.Group
                                                    as={Col}
                                                    sm={4}
                                                    controlId="price_6_percent"
                                                    className="px-3 col-8"
                                                >
                                                    <InputGroup>
                                                        <InputGroup.Append>
                                                            <InputGroup.Text id="inputGroupPrepend">
                                                                %
                                                            </InputGroup.Text>
                                                        </InputGroup.Append>
                                                        <Form.Control
                                                            type="text"
                                                            name="price_6_percent"
                                                            value={
                                                                values.price_6_percent
                                                            }
                                                            onChange={
                                                                handleChange
                                                            }
                                                            aria-describedby="inputGroupPrepend"
                                                            required
                                                            className="preapp-form-input"
                                                        />

                                                        <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                    </InputGroup>
                                                    <Form.Control.Feedback
                                                        type="invalid"
                                                        className="text-capitalize"
                                                    >
                                                        {errors.price_6_percent}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group
                                                    as={Col}
                                                    sm={2}
                                                    controlId="price_6_dollars"
                                                    className="px-3 col-4"
                                                >
                                                    <InputGroup>
                                                        <Form.Control
                                                            type="text"
                                                            name="price_6_dollars"
                                                            value={
                                                                values.price_6_dollars
                                                            }
                                                            onChange={
                                                                handleChange
                                                            }
                                                            aria-describedby="inputGroupPrepend"
                                                            required
                                                            className="preapp-form-input"
                                                        />
                                                        <InputGroup.Prepend>
                                                            <InputGroup.Text id="inputGroupPrepend">
                                                                $
                                                            </InputGroup.Text>
                                                        </InputGroup.Prepend>
                                                        <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                    </InputGroup>
                                                    <Form.Control.Feedback
                                                        type="invalid"
                                                        className="text-capitalize"
                                                    >
                                                        {errors.price_6_dollars}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Form.Row>
                                        </div>
                                    )}

                                    <section className=" pr-fees">
                                        <h2 className="price-frm-heading  head-top gen-fees">
                                            General fees
                                        </h2>
                                        <Row>
                                            <div className="new-div row px-3 ">
                                                <Form.Row>
                                                    <Form.Group as={Col} sm={6}>
                                                        <Form.Label>
                                                            Service (Monthly)
                                                        </Form.Label>
                                                    </Form.Group>
                                                    <Form.Group
                                                        as={Col}
                                                        xs={8}
                                                        sm={4}
                                                        controlId="price_17_dollars"
                                                        className=""
                                                    >
                                                        <InputGroup>
                                                            <InputGroup.Prepend>
                                                                <InputGroup.Text id="inputGroupPrepend">
                                                                    $
                                                                </InputGroup.Text>
                                                            </InputGroup.Prepend>
                                                            <Form.Control
                                                                type="text"
                                                                name="price_17_dollars"
                                                                value={
                                                                    values.price_17_dollars
                                                                }
                                                                onChange={
                                                                    handleChange
                                                                }
                                                                aria-describedby="inputGroupPrepend"
                                                                required
                                                                className="preapp-form-input"
                                                                isInvalid={
                                                                    touched.price_17_dollars &&
                                                                    !!errors.price_17_dollars
                                                                }
                                                                isValid={
                                                                    is_submitted &&
                                                                    !errors.price_17_dollars
                                                                }
                                                            />
                                                        </InputGroup>
                                                        <Form.Control.Feedback
                                                            type="invalid"
                                                            className="text-capitalize"
                                                        >
                                                            {
                                                                errors.price_17_dollars
                                                            }
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                </Form.Row>
                                            </div>

                                            <div className="new-div row px-3 ">
                                                <Form.Row>
                                                    <Form.Group as={Col} sm={6}>
                                                        <Form.Label>
                                                            Authorization (Per
                                                            Item)
                                                        </Form.Label>
                                                    </Form.Group>

                                                    <Form.Group
                                                        as={Col}
                                                        xs={8}
                                                        sm={4}
                                                        controlId="price_11_dollars"
                                                    >
                                                        <InputGroup>
                                                            <InputGroup.Prepend>
                                                                <InputGroup.Text id="inputGroupPrepend">
                                                                    $
                                                                </InputGroup.Text>
                                                            </InputGroup.Prepend>
                                                            <Form.Control
                                                                type="text"
                                                                name="price_11_dollars"
                                                                value={
                                                                    values.price_11_dollars
                                                                }
                                                                onChange={
                                                                    handleChange
                                                                }
                                                                aria-describedby="inputGroupPrepend"
                                                                required
                                                                className="preapp-form-input"
                                                            />
                                                            <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                        </InputGroup>
                                                        <Form.Control.Feedback
                                                            type="invalid"
                                                            className="text-capitalize"
                                                        >
                                                            {
                                                                errors.price_11_dollars
                                                            }
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                </Form.Row>
                                            </div>

                                            <div className="new-div row px-3 ">
                                                <Form.Row>
                                                    <Form.Group as={Col} sm={6}>
                                                        <Form.Label>
                                                            Batch Header (Per
                                                            Batch)
                                                        </Form.Label>
                                                    </Form.Group>

                                                    <Form.Group
                                                        as={Col}
                                                        xs={8}
                                                        sm={4}
                                                        controlId="price_14_dollars"
                                                    >
                                                        <InputGroup>
                                                            <InputGroup.Prepend>
                                                                <InputGroup.Text id="inputGroupPrepend">
                                                                    $
                                                                </InputGroup.Text>
                                                            </InputGroup.Prepend>
                                                            <Form.Control
                                                                type="text"
                                                                name="price_14_dollars"
                                                                value={
                                                                    values.price_14_dollars
                                                                }
                                                                onChange={
                                                                    handleChange
                                                                }
                                                                aria-describedby="inputGroupPrepend"
                                                                required
                                                                className="preapp-form-input"
                                                                isInvalid={
                                                                    touched.price_14_dollars &&
                                                                    !!errors.price_14_dollars
                                                                }
                                                                isValid={
                                                                    is_submitted &&
                                                                    !errors.price_14_dollars
                                                                }
                                                            />
                                                        </InputGroup>
                                                        <Form.Control.Feedback
                                                            type="invalid"
                                                            className="text-capitalize"
                                                        >
                                                            {
                                                                errors.price_14_dollars
                                                            }
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                </Form.Row>
                                            </div>

                                            <div className="new-div row px-3 ">
                                                <Form.Row>
                                                    <Form.Group as={Col} sm={6}>
                                                        <Form.Label>
                                                            Voice Authorization
                                                            (Per Item)
                                                        </Form.Label>
                                                    </Form.Group>

                                                    <Form.Group
                                                        as={Col}
                                                        xs={8}
                                                        sm={4}
                                                        controlId="price_12_dollars"
                                                    >
                                                        <InputGroup>
                                                            <InputGroup.Prepend>
                                                                <InputGroup.Text id="inputGroupPrepend">
                                                                    $
                                                                </InputGroup.Text>
                                                            </InputGroup.Prepend>
                                                            <Form.Control
                                                                type="text"
                                                                name="price_12_dollars"
                                                                value={
                                                                    values.price_12_dollars
                                                                }
                                                                onChange={
                                                                    handleChange
                                                                }
                                                                aria-describedby="inputGroupPrepend"
                                                                required
                                                                className="preapp-form-input"
                                                            />
                                                            <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                        </InputGroup>
                                                        <Form.Control.Feedback
                                                            type="invalid"
                                                            className="text-capitalize"
                                                        >
                                                            {
                                                                errors.price_12_dollars
                                                            }
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                </Form.Row>
                                            </div>

                                            <div className="new-div row px-3 ">
                                                <Form.Row>
                                                    <Form.Group as={Col} sm={6}>
                                                        <Form.Label>
                                                            Chargeback (Per
                                                            Item)
                                                        </Form.Label>
                                                    </Form.Group>

                                                    <Form.Group
                                                        as={Col}
                                                        xs={8}
                                                        sm={4}
                                                        controlId="price_20_dollars"
                                                    >
                                                        <InputGroup>
                                                            <InputGroup.Prepend>
                                                                <InputGroup.Text id="inputGroupPrepend">
                                                                    $
                                                                </InputGroup.Text>
                                                            </InputGroup.Prepend>
                                                            <Form.Control
                                                                type="text"
                                                                name="price_20_dollars"
                                                                value={
                                                                    values.price_20_dollars
                                                                }
                                                                onChange={
                                                                    handleChange
                                                                }
                                                                aria-describedby="inputGroupPrepend"
                                                                required
                                                                className="preapp-form-input"
                                                                isInvalid={
                                                                    touched.price_20_dollars &&
                                                                    !!errors.price_20_dollars
                                                                }
                                                                isValid={
                                                                    is_submitted &&
                                                                    !errors.price_20_dollars
                                                                }
                                                            />
                                                        </InputGroup>
                                                        <Form.Control.Feedback
                                                            type="invalid"
                                                            className="text-capitalize"
                                                        >
                                                            {
                                                                errors.price_20_dollars
                                                            }
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                </Form.Row>
                                            </div>
                                            <div className="new-div row px-3 ">
                                                <Form.Row>
                                                    <Form.Group as={Col} sm={6}>
                                                        <Form.Label>
                                                            Retrieval (Per Item)
                                                        </Form.Label>
                                                    </Form.Group>
                                                    <Form.Group
                                                        as={Col}
                                                        xs={8}
                                                        sm={4}
                                                        controlId="price_21_dollars"
                                                    >
                                                        <InputGroup>
                                                            <InputGroup.Prepend>
                                                                <InputGroup.Text id="inputGroupPrepend">
                                                                    $
                                                                </InputGroup.Text>
                                                            </InputGroup.Prepend>
                                                            <Form.Control
                                                                type="text"
                                                                name="price_21_dollars"
                                                                value={
                                                                    values.price_21_dollars
                                                                }
                                                                onChange={
                                                                    handleChange
                                                                }
                                                                aria-describedby="inputGroupPrepend"
                                                                required
                                                                className="preapp-form-input"
                                                                isInvalid={
                                                                    touched.price_21_dollars &&
                                                                    !!errors.price_21_dollars
                                                                }
                                                                isValid={
                                                                    is_submitted &&
                                                                    !errors.price_21_dollars
                                                                }
                                                            />
                                                        </InputGroup>
                                                        <Form.Control.Feedback
                                                            type="invalid"
                                                            className="text-capitalize"
                                                        >
                                                            {
                                                                errors.price_21_dollars
                                                            }
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                </Form.Row>
                                            </div>

                                            <div className="new-div row px-3 ">
                                                <Form.Row>
                                                    <Form.Group as={Col} sm={6}>
                                                        <Form.Label>
                                                            NSF/ACH Reject (Per
                                                            Item)
                                                        </Form.Label>
                                                    </Form.Group>

                                                    <Form.Group
                                                        as={Col}
                                                        xs={8}
                                                        sm={4}
                                                        controlId="price_22_dollars"
                                                    >
                                                        <InputGroup>
                                                            <InputGroup.Prepend>
                                                                <InputGroup.Text id="inputGroupPrepend">
                                                                    $
                                                                </InputGroup.Text>
                                                            </InputGroup.Prepend>
                                                            <Form.Control
                                                                type="text"
                                                                name="price_22_dollars"
                                                                value={
                                                                    values.price_22_dollars
                                                                }
                                                                onChange={
                                                                    handleChange
                                                                }
                                                                aria-describedby="inputGroupPrepend"
                                                                required
                                                                className="preapp-form-input"
                                                                isInvalid={
                                                                    touched.price_22_dollars &&
                                                                    !!errors.price_22_dollars
                                                                }
                                                                isValid={
                                                                    is_submitted &&
                                                                    !errors.price_22_dollars
                                                                }
                                                            />
                                                        </InputGroup>
                                                        <Form.Control.Feedback
                                                            type="invalid"
                                                            className="text-capitalize"
                                                        >
                                                            {
                                                                errors.price_22_dollars
                                                            }
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                </Form.Row>
                                            </div>

                                            <div className="new-div row px-3 ">
                                                <Form.Row>
                                                    <Form.Group as={Col} sm={6}>
                                                        <Form.Label>
                                                            Monthly Minimum
                                                            (minimum discount)
                                                        </Form.Label>
                                                    </Form.Group>

                                                    <Form.Group
                                                        as={Col}
                                                        xs={8}
                                                        sm={4}
                                                        controlId="price_18_dollars"
                                                    >
                                                        <InputGroup>
                                                            <InputGroup.Prepend>
                                                                <InputGroup.Text id="inputGroupPrepend">
                                                                    $
                                                                </InputGroup.Text>
                                                            </InputGroup.Prepend>
                                                            <Form.Control
                                                                type="text"
                                                                name="price_18_dollars"
                                                                value={
                                                                    values.price_18_dollars
                                                                }
                                                                onChange={
                                                                    handleChange
                                                                }
                                                                aria-describedby="inputGroupPrepend"
                                                                required
                                                                className="preapp-form-input"
                                                            />
                                                            <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                        </InputGroup>
                                                        <Form.Control.Feedback
                                                            type="invalid"
                                                            className="text-capitalize"
                                                        >
                                                            {
                                                                errors.price_18_dollars
                                                            }
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                </Form.Row>
                                            </div>

                                            <div className="new-div row px-3 ">
                                                <Form.Row>
                                                    <Form.Group as={Col} sm={6}>
                                                        <Form.Label>
                                                            Annual Fee
                                                        </Form.Label>
                                                    </Form.Group>

                                                    <Form.Group
                                                        as={Col}
                                                        xs={8}
                                                        sm={4}
                                                        controlId="price_25_dollars"
                                                        // className="px-3 deb-monthly"
                                                    >
                                                        <InputGroup>
                                                            <InputGroup.Prepend>
                                                                <InputGroup.Text id="inputGroupPrepend">
                                                                    $
                                                                </InputGroup.Text>
                                                            </InputGroup.Prepend>
                                                            <Form.Control
                                                                type="text"
                                                                name="price_25_dollars"
                                                                value={
                                                                    values.price_25_dollars
                                                                }
                                                                onChange={
                                                                    handleChange
                                                                }
                                                                aria-describedby="inputGroupPrepend"
                                                                required
                                                                className="preapp-form-input"
                                                            />
                                                            <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                        </InputGroup>
                                                        <Form.Control.Feedback
                                                            type="invalid"
                                                            className="text-capitalize"
                                                        >
                                                            {
                                                                errors.price_25_dollars
                                                            }
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                </Form.Row>
                                            </div>
                                            <div className="new-div row px-3 ">
                                                <Form.Row>
                                                    <Form.Group as={Col} sm={6}>
                                                        <Form.Label>
                                                            AVS Fee
                                                        </Form.Label>
                                                    </Form.Group>

                                                    <Form.Group
                                                        as={Col}
                                                        xs={8}
                                                        sm={4}
                                                        controlId="price_13_dollars"
                                                    >
                                                        <InputGroup>
                                                            <InputGroup.Prepend>
                                                                <InputGroup.Text id="inputGroupPrepend">
                                                                    $
                                                                </InputGroup.Text>
                                                            </InputGroup.Prepend>
                                                            <Form.Control
                                                                type="text"
                                                                name="price_13_dollars"
                                                                value={
                                                                    values.price_13_dollars
                                                                }
                                                                onChange={
                                                                    handleChange
                                                                }
                                                                aria-describedby="inputGroupPrepend"
                                                                required
                                                                className="preapp-form-input"
                                                            />
                                                            <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                        </InputGroup>
                                                        <Form.Control.Feedback
                                                            type="invalid"
                                                            className="text-capitalize"
                                                        >
                                                            {
                                                                errors.price_13_dollars
                                                            }
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                </Form.Row>
                                            </div>

                                            <div className="new-div row px-3 ">
                                                <Form.Row>
                                                    <Form.Group as={Col} sm={6}>
                                                        <Form.Label>
                                                            Early closure (ETF)
                                                        </Form.Label>
                                                    </Form.Group>

                                                    <Form.Group
                                                        as={Col}
                                                        xs={8}
                                                        sm={4}
                                                        controlId="price_27_dollars"
                                                    >
                                                        <InputGroup>
                                                            <InputGroup.Prepend>
                                                                <InputGroup.Text id="inputGroupPrepend">
                                                                    $
                                                                </InputGroup.Text>
                                                            </InputGroup.Prepend>
                                                            <Form.Control
                                                                type="text"
                                                                name="price_27_dollars"
                                                                value={
                                                                    values.price_27_dollars
                                                                }
                                                                onChange={
                                                                    handleChange
                                                                }
                                                                aria-describedby="inputGroupPrepend"
                                                                required
                                                                className="preapp-form-input"
                                                            />
                                                            <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                        </InputGroup>
                                                        <Form.Control.Feedback
                                                            type="invalid"
                                                            className="text-capitalize"
                                                        >
                                                            {
                                                                errors.price_27_dollars
                                                            }
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                </Form.Row>
                                            </div>
                                            {values.qualifiedtype !==
                                                "sccd" && (
                                                <div>
                                                    <Col
                                                        xs={12}
                                                        lg={12}
                                                        className="service-fees new-div"
                                                    >
                                                        <h2 className="price-frm-heading  head-top">
                                                            {" "}
                                                            EBT Fees
                                                        </h2>
                                                        <div className=" pri-heading1">
                                                            Does Merchant Accept
                                                            EBT?
                                                        </div>

                                                        <div className="form-group d-flex tire-new">
                                                            <label className="radio-container">
                                                                <input
                                                                    type="radio"
                                                                    name="ebt_fees"
                                                                    value="yes"
                                                                    checked={
                                                                        values.ebt_fees ==
                                                                        "yes"
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                />
                                                                <span className="checkmark"></span>
                                                                <span className="rd-label">
                                                                    Yes
                                                                </span>
                                                            </label>

                                                            <label className="radio-container">
                                                                <input
                                                                    type="radio"
                                                                    name="ebt_fees"
                                                                    value="no"
                                                                    checked={
                                                                        values.ebt_fees ==
                                                                        "no"
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                />
                                                                <span className="checkmark"></span>
                                                                <span className="rd-label">
                                                                    No
                                                                </span>
                                                            </label>
                                                        </div>
                                                        {values.ebt_fees ===
                                                            "yes" && (
                                                            <Accordion eventkey="0">
                                                                <Card>
                                                                    <Accordion.Collapse
                                                                        eventkey="0"
                                                                        className={
                                                                            values.ebt_fees
                                                                                ? "show"
                                                                                : ""
                                                                        }
                                                                    >
                                                                        <Card.Body>
                                                                            <Row>
                                                                                <Form.Group
                                                                                    as={
                                                                                        Col
                                                                                    }
                                                                                    xs={
                                                                                        8
                                                                                    }
                                                                                    lg={
                                                                                        6
                                                                                    }
                                                                                    controlId="price_29_dollars"
                                                                                    className="px-3"
                                                                                >
                                                                                    <Form.Label className="preapp-form-label">
                                                                                        EBT
                                                                                        Transactions
                                                                                        (Per
                                                                                        Item)
                                                                                    </Form.Label>

                                                                                    <InputGroup>
                                                                                        <InputGroup.Prepend>
                                                                                            <InputGroup.Text id="inputGroupPrepend">
                                                                                                $
                                                                                            </InputGroup.Text>
                                                                                        </InputGroup.Prepend>
                                                                                        <Form.Control
                                                                                            type="text"
                                                                                            name="price_29_dollars"
                                                                                            value={
                                                                                                values.price_29_dollars
                                                                                            }
                                                                                            onChange={
                                                                                                handleChange
                                                                                            }
                                                                                            aria-describedby="inputGroupPrepend"
                                                                                            required
                                                                                            className="preapp-form-input"
                                                                                        />
                                                                                        <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                                                    </InputGroup>
                                                                                    <Form.Control.Feedback
                                                                                        type="invalid"
                                                                                        className="text-capitalize"
                                                                                    >
                                                                                        {
                                                                                            errors.price_29_dollars
                                                                                        }
                                                                                    </Form.Control.Feedback>
                                                                                </Form.Group>

                                                                                <Form.Group
                                                                                    as={
                                                                                        Col
                                                                                    }
                                                                                    xs={
                                                                                        8
                                                                                    }
                                                                                    lg={
                                                                                        6
                                                                                    }
                                                                                    controlId="price_30_dollars"
                                                                                    className="px-3"
                                                                                >
                                                                                    <Form.Label className="preapp-form-label">
                                                                                        EBT
                                                                                        Transaction
                                                                                        (Monthly)
                                                                                    </Form.Label>
                                                                                    <InputGroup>
                                                                                        <InputGroup.Prepend>
                                                                                            <InputGroup.Text id="inputGroupPrepend">
                                                                                                $
                                                                                            </InputGroup.Text>
                                                                                        </InputGroup.Prepend>
                                                                                        <Form.Control
                                                                                            type="text"
                                                                                            name="price_30_dollars"
                                                                                            value={
                                                                                                values.price_30_dollars
                                                                                            }
                                                                                            onChange={
                                                                                                handleChange
                                                                                            }
                                                                                            aria-describedby="inputGroupPrepend"
                                                                                            required
                                                                                            className="preapp-form-input"
                                                                                        />
                                                                                        <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                                                    </InputGroup>
                                                                                    <Form.Control.Feedback
                                                                                        type="invalid"
                                                                                        className="text-capitalize"
                                                                                    >
                                                                                        {
                                                                                            errors.price_30_dollars
                                                                                        }
                                                                                    </Form.Control.Feedback>
                                                                                </Form.Group>

                                                                                <Form.Group
                                                                                    as={
                                                                                        Col
                                                                                    }
                                                                                    xs={
                                                                                        8
                                                                                    }
                                                                                    lg={
                                                                                        6
                                                                                    }
                                                                                    controlId="price_31_dollars"
                                                                                    className="px-3"
                                                                                >
                                                                                    {" "}
                                                                                    <Form.Label className="preapp-form-label">
                                                                                        EBT
                                                                                        Reg
                                                                                        Number
                                                                                    </Form.Label>
                                                                                    <InputGroup>
                                                                                        <InputGroup.Prepend>
                                                                                            <InputGroup.Text id="inputGroupPrepend"></InputGroup.Text>
                                                                                        </InputGroup.Prepend>
                                                                                        <Form.Control
                                                                                            type="text"
                                                                                            name="price_31_dollars"
                                                                                            value={
                                                                                                values.price_31_dollars
                                                                                            }
                                                                                            onChange={
                                                                                                handleChange
                                                                                            }
                                                                                            aria-describedby="inputGroupPrepend"
                                                                                            required
                                                                                            className="preapp-form-input"
                                                                                        />
                                                                                        <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                                                    </InputGroup>
                                                                                    <Form.Control.Feedback
                                                                                        type="invalid"
                                                                                        className="text-capitalize"
                                                                                    >
                                                                                        {
                                                                                            errors.price_31_dollars
                                                                                        }
                                                                                    </Form.Control.Feedback>
                                                                                </Form.Group>
                                                                            </Row>
                                                                        </Card.Body>
                                                                    </Accordion.Collapse>
                                                                </Card>
                                                            </Accordion>
                                                        )}
                                                    </Col>
                                                </div>
                                            )}
                                        </Row>
                                    </section>

                                    {values.qualifiedtype !== "sccd" && (
                                        <section className="amr-exp">
                                            <h2 className="price-frm-heading head-top">
                                                AMERICAN EXPRESS
                                            </h2>
                                            <div className="new-div row px-3 outfrom">
                                                <div className=" pri-heading1">
                                                    Opt out from American
                                                    Express?
                                                </div>
                                                <Form.Group
                                                    as={Col}
                                                    xs={12}
                                                    controlId="apexoptout"
                                                    className="px-3"
                                                >
                                                    <div>
                                                        <label className="radio-container">
                                                            <input
                                                                type="radio"
                                                                name="apexoptout"
                                                                value="yes"
                                                                checked={
                                                                    values.apexoptout ===
                                                                    "yes"
                                                                }
                                                                onChange={
                                                                    handleChange
                                                                }
                                                            />

                                                            <span className="checkmark"></span>
                                                            <span className="rd-label">
                                                                Yes
                                                            </span>
                                                        </label>
                                                        <label className="radio-container">
                                                            <input
                                                                type="radio"
                                                                name="apexoptout"
                                                                value="no"
                                                                checked={
                                                                    values.apexoptout ===
                                                                    "no"
                                                                }
                                                                onChange={
                                                                    handleChange
                                                                }
                                                            />
                                                            <span className="checkmark"></span>
                                                            <span className="rd-label">
                                                                No
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <Form.Control.Feedback
                                                        type="invalid"
                                                        className="text-capitalize"
                                                    >
                                                        {errors.apexoptout}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </div>
                                            {values.apexoptout === "no" && (
                                                <>
                                                    {(values.qualifiedtype ===
                                                        "icppt" ||
                                                        values.qualifiedtype ===
                                                            "frate") && (
                                                        <div className="new-div row px-3 ">
                                                            <Form.Row>
                                                                <Form.Group
                                                                    as={Col}
                                                                    sm={6}
                                                                >
                                                                    <Form.Label>
                                                                        Passthrough
                                                                        (Per
                                                                        Item)
                                                                    </Form.Label>
                                                                    <div className="float-right">
                                                                        {values.qualifiedtype ===
                                                                        "icppt" ? (
                                                                            <span>
                                                                                IC+
                                                                            </span>
                                                                        ) : (
                                                                            ""
                                                                        )}
                                                                    </div>
                                                                </Form.Group>

                                                                <Form.Group
                                                                    as={Col}
                                                                    sm={4}
                                                                    controlId="price_35_percent"
                                                                    className="px-3 new-div col-8"
                                                                >
                                                                    <InputGroup>
                                                                        <InputGroup.Append>
                                                                            <InputGroup.Text id="inputGroupPrepend">
                                                                                %
                                                                            </InputGroup.Text>
                                                                        </InputGroup.Append>
                                                                        <Form.Control
                                                                            type="text"
                                                                            name="price_35_percent"
                                                                            value={
                                                                                values.price_35_percent
                                                                            }
                                                                            onChange={
                                                                                handleChange
                                                                            }
                                                                            aria-describedby="inputGroupPrepend"
                                                                            required
                                                                            className="preapp-form-input"
                                                                        />

                                                                        <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                                    </InputGroup>
                                                                    <Form.Control.Feedback
                                                                        type="invalid"
                                                                        className="text-capitalize"
                                                                    >
                                                                        {
                                                                            errors.price_35_percent
                                                                        }
                                                                    </Form.Control.Feedback>
                                                                </Form.Group>
                                                                <Form.Group
                                                                    as={Col}
                                                                    sm={2}
                                                                    controlId="price_35_dollars"
                                                                    className="col-4"
                                                                >
                                                                    <InputGroup>
                                                                        <InputGroup.Prepend>
                                                                            <InputGroup.Text id="inputGroupPrepend">
                                                                                $
                                                                            </InputGroup.Text>
                                                                        </InputGroup.Prepend>
                                                                        <Form.Control
                                                                            type="text"
                                                                            name="price_35_dollars"
                                                                            value={
                                                                                values.price_35_dollars
                                                                            }
                                                                            onChange={
                                                                                handleChange
                                                                            }
                                                                            aria-describedby="inputGroupPrepend"
                                                                            required
                                                                            className="preapp-form-input"
                                                                        />
                                                                        <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                                                                    </InputGroup>
                                                                    <Form.Control.Feedback
                                                                        type="invalid"
                                                                        className="text-capitalize"
                                                                    >
                                                                        {
                                                                            errors.price_35_dollars
                                                                        }
                                                                    </Form.Control.Feedback>
                                                                </Form.Group>
                                                            </Form.Row>
                                                        </div>
                                                    )}

                                                    {(values.qualifiedtype ===
                                                        "tiered" ||
                                                        values.qualifiedtype ===
                                                            "sccd") && (
                                                        <>
                                                            <div className="new-div row px-3 ">
                                                                <Form.Row>
                                                                    <Form.Group
                                                                        as={Col}
                                                                        sm={5}
                                                                    >
                                                                        <Form.Label>
                                                                            {
                                                                                "Tier 1 (<$150):"
                                                                            }
                                                                        </Form.Label>
                                                                    </Form.Group>

                                                                    <Form.Group
                                                                        as={Col}
                                                                        sm={4}
                                                                        controlId="price_32_percent"
                                                                        className="col-8"
                                                                    >
                                                                        <InputGroup>
                                                                            <InputGroup.Append>
                                                                                <InputGroup.Text id="inputGroupPrepend">
                                                                                    %
                                                                                </InputGroup.Text>
                                                                            </InputGroup.Append>
                                                                            <Form.Control
                                                                                type="text"
                                                                                name="price_32_percent"
                                                                                value={
                                                                                    values.price_32_percent
                                                                                }
                                                                                onChange={
                                                                                    handleChange
                                                                                }
                                                                                aria-describedby="inputGroupPrepend"
                                                                                required
                                                                                className="preapp-form-input"
                                                                                isInvalid={
                                                                                    touched.price_32_percent &&
                                                                                    !!errors.price_32_percent
                                                                                }
                                                                                isValid={
                                                                                    is_submitted &&
                                                                                    !errors.price_32_percent
                                                                                }
                                                                            />
                                                                        </InputGroup>
                                                                        <Form.Control.Feedback
                                                                            type="invalid"
                                                                            className="text-capitalize"
                                                                        >
                                                                            {
                                                                                errors.price_32_percent
                                                                            }
                                                                        </Form.Control.Feedback>
                                                                    </Form.Group>

                                                                    <Form.Group
                                                                        as={Col}
                                                                        sm={2}
                                                                        controlId="price_32_dollars"
                                                                        className="col-4 "
                                                                    >
                                                                        <InputGroup>
                                                                            <Form.Control
                                                                                type="text"
                                                                                name="price_32_dollars"
                                                                                value={
                                                                                    values.price_32_dollars
                                                                                }
                                                                                onChange={
                                                                                    handleChange
                                                                                }
                                                                                aria-describedby="inputGroupPrepend"
                                                                                required
                                                                                className="preapp-form-input"
                                                                                isInvalid={
                                                                                    touched.price_32_dollars &&
                                                                                    !!errors.price_32_dollars
                                                                                }
                                                                                isValid={
                                                                                    is_submitted &&
                                                                                    !errors.price_32_dollars
                                                                                }
                                                                            />
                                                                            <InputGroup.Prepend>
                                                                                <InputGroup.Text id="inputGroupPrepend">
                                                                                    $
                                                                                </InputGroup.Text>
                                                                            </InputGroup.Prepend>
                                                                        </InputGroup>
                                                                        <Form.Control.Feedback
                                                                            type="invalid"
                                                                            className="text-capitalize"
                                                                        >
                                                                            {
                                                                                errors.price_32_dollars
                                                                            }
                                                                        </Form.Control.Feedback>
                                                                    </Form.Group>

                                                                    <Form.Group
                                                                        as={Col}
                                                                        sm={1}
                                                                        className="px-3"
                                                                    >
                                                                        {" "}
                                                                        <Button
                                                                            onClick={() =>
                                                                                this.copyValues(
                                                                                    values,
                                                                                )
                                                                            }
                                                                            variant="outline-primary"
                                                                            className="btn-lmd btn-copy confirm-button"
                                                                        >
                                                                            Copy
                                                                        </Button>
                                                                    </Form.Group>
                                                                </Form.Row>
                                                            </div>
                                                            <div className="new-div row px-3 ">
                                                                <Form.Row>
                                                                    <Form.Group
                                                                        as={Col}
                                                                        sm={5}
                                                                    >
                                                                        <Form.Label>
                                                                            Tier
                                                                            2($150
                                                                            -
                                                                            $3,000):
                                                                        </Form.Label>
                                                                    </Form.Group>
                                                                    <Form.Group
                                                                        as={Col}
                                                                        sm={4}
                                                                        controlId="price_33_percent"
                                                                        className="col-8"
                                                                    >
                                                                        <InputGroup>
                                                                            <InputGroup.Append>
                                                                                <InputGroup.Text id="inputGroupPrepend">
                                                                                    %
                                                                                </InputGroup.Text>
                                                                            </InputGroup.Append>
                                                                            <Form.Control
                                                                                type="text"
                                                                                name="price_33_percent"
                                                                                value={
                                                                                    values.price_33_percent
                                                                                }
                                                                                onChange={
                                                                                    handleChange
                                                                                }
                                                                                aria-describedby="inputGroupPrepend"
                                                                                required
                                                                                className="preapp-form-input"
                                                                                isInvalid={
                                                                                    touched.price_33_percent &&
                                                                                    !!errors.price_33_percent
                                                                                }
                                                                                isValid={
                                                                                    is_submitted &&
                                                                                    !errors.price_33_percent
                                                                                }
                                                                            />
                                                                        </InputGroup>
                                                                        <Form.Control.Feedback
                                                                            type="invalid"
                                                                            className="text-capitalize"
                                                                        >
                                                                            {
                                                                                errors.price_33_percent
                                                                            }
                                                                        </Form.Control.Feedback>
                                                                    </Form.Group>
                                                                    <Form.Group
                                                                        as={Col}
                                                                        sm={2}
                                                                        controlId="price_33_dollars"
                                                                        className="col-4"
                                                                    >
                                                                        <InputGroup>
                                                                            <Form.Control
                                                                                type="text"
                                                                                name="price_33_dollars"
                                                                                value={
                                                                                    values.price_33_dollars
                                                                                }
                                                                                onChange={
                                                                                    handleChange
                                                                                }
                                                                                aria-describedby="inputGroupPrepend"
                                                                                required
                                                                                className="preapp-form-input"
                                                                                isInvalid={
                                                                                    touched.price_33_dollars &&
                                                                                    !!errors.price_33_dollars
                                                                                }
                                                                                isValid={
                                                                                    is_submitted &&
                                                                                    !errors.price_33_dollars
                                                                                }
                                                                            />
                                                                            <InputGroup.Prepend>
                                                                                <InputGroup.Text id="inputGroupPrepend">
                                                                                    $
                                                                                </InputGroup.Text>
                                                                            </InputGroup.Prepend>
                                                                        </InputGroup>
                                                                        <Form.Control.Feedback
                                                                            type="invalid"
                                                                            className="text-capitalize"
                                                                        >
                                                                            {
                                                                                errors.price_33_dollars
                                                                            }
                                                                        </Form.Control.Feedback>
                                                                    </Form.Group>
                                                                </Form.Row>
                                                            </div>
                                                            <div className="new-div row px-3 ">
                                                                <Form.Row>
                                                                    <Form.Group
                                                                        as={Col}
                                                                        sm={5}
                                                                    >
                                                                        <Form.Label>
                                                                            Tier
                                                                            3
                                                                            (&gt;$3,000)
                                                                        </Form.Label>
                                                                    </Form.Group>
                                                                    <Form.Group
                                                                        as={Col}
                                                                        sm={4}
                                                                        controlId="price_34_percent"
                                                                        className="col-8"
                                                                    >
                                                                        <InputGroup>
                                                                            <InputGroup.Append>
                                                                                <InputGroup.Text id="inputGroupPrepend">
                                                                                    %
                                                                                </InputGroup.Text>
                                                                            </InputGroup.Append>
                                                                            <Form.Control
                                                                                type="text"
                                                                                name="price_34_percent"
                                                                                value={
                                                                                    values.price_34_percent
                                                                                }
                                                                                onChange={
                                                                                    handleChange
                                                                                }
                                                                                aria-describedby="inputGroupPrepend"
                                                                                required
                                                                                className="preapp-form-input"
                                                                                isInvalid={
                                                                                    touched.price_34_percent &&
                                                                                    !!errors.price_34_percent
                                                                                }
                                                                                isValid={
                                                                                    is_submitted &&
                                                                                    !errors.price_34_percent
                                                                                }
                                                                            />
                                                                        </InputGroup>
                                                                        <Form.Control.Feedback
                                                                            type="invalid"
                                                                            className="text-capitalize"
                                                                        >
                                                                            {
                                                                                errors.price_34_percent
                                                                            }
                                                                        </Form.Control.Feedback>
                                                                    </Form.Group>
                                                                    <Form.Group
                                                                        as={Col}
                                                                        sm={2}
                                                                        controlId="price_34_dollars"
                                                                        className="col-4"
                                                                    >
                                                                        <InputGroup>
                                                                            <Form.Control
                                                                                type="text"
                                                                                name="price_34_dollars"
                                                                                value={
                                                                                    values.price_34_dollars
                                                                                }
                                                                                onChange={
                                                                                    handleChange
                                                                                }
                                                                                aria-describedby="inputGroupPrepend"
                                                                                required
                                                                                className="preapp-form-input"
                                                                                isInvalid={
                                                                                    touched.price_34_dollars &&
                                                                                    !!errors.price_34_dollars
                                                                                }
                                                                                isValid={
                                                                                    is_submitted &&
                                                                                    !errors.price_34_dollars
                                                                                }
                                                                            />
                                                                            <InputGroup.Prepend>
                                                                                <InputGroup.Text id="inputGroupPrepend">
                                                                                    $
                                                                                </InputGroup.Text>
                                                                            </InputGroup.Prepend>
                                                                        </InputGroup>
                                                                        <Form.Control.Feedback
                                                                            type="invalid"
                                                                            className="text-capitalize"
                                                                        >
                                                                            {
                                                                                errors.price_34_dollars
                                                                            }
                                                                        </Form.Control.Feedback>
                                                                    </Form.Group>
                                                                </Form.Row>
                                                            </div>
                                                        </>
                                                    )}
                                                </>
                                            )}
                                        </section>
                                    )}
                                    {show_spinner ? (
                                        <div className="spinner">
                                            <Loader />
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                </Form.Row>

                                <div className="modal-footer">
                                    <p className="error-message text-center form-group col-sm-12">
                                        {this.state.errorMessage}
                                    </p>
                                    <div className="button-twoc">
                                        <button
                                            type="submit"
                                            className="btn confirm-button"
                                            disabled={show_spinner}
                                            onClick={() => {
                                                this.setState({
                                                    formData: values,
                                                });
                                            }}
                                        >
                                            {isEdit ? "Update" : "Add"}
                                        </button>
                                        <button
                                            type="button"
                                            className="btn cancel-button"
                                            onClick={() =>
                                                this.props.handleClose()
                                            }
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </ReactModal>
        );
    }
}

export default EditPricingCreateApp;
